import { Avatar, Tooltip } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { Venue as VenueModel } from '../../models/Venue'
import { useAppSelector } from '../../store/hooks'
import { selectVenuesByIds } from '../../store/VenueReducer'
import { VenueAvatar } from './Avatar'

interface Props {
  ids: number[]
  models?: VenueModel[]
  size?: AvatarProps['size']
  maxCount?: number
}

export const VenueAvatarGroup = ({
  ids,
  models,
  size = 'default',
  maxCount = 4,
}: Props) => {
  const venues = models ? models : useAppSelector(selectVenuesByIds(ids))

  if (!venues) {
    return <></>
  }

  return (
    <Avatar.Group
      shape="square"
      size={size}
      max={{
        count: maxCount,
        style: {
          color: '#fff',
          backgroundColor: '#8e978a',
        },
      }}
    >
      {venues.map((venue) => (
        <Tooltip title={venue.name} key={venue.id}>
          <VenueAvatar size={size} model={venue} type="condensed" />
        </Tooltip>
      ))}
    </Avatar.Group>
  )
}

export type VenueAvatarGroupType = { AvatarGroup: typeof VenueAvatarGroup }
